export default __webpack_public_path__ + "static/char-s-49-zh-Hans-b91eeb8e05c897cbd3f9bcb945eca766.webp";